export default "__VITE_ASSET__TLR$L2zb__";